module.exports = __webpack_public_path__ + "static/media/Stays1830.3a04f2c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/history/Stays1830.png
// module id = 194
// module chunks = 0